module.exports = __webpack_public_path__ + "media/icons/download-app-store-f8952c90.svg";